<div class="request-header" xmlns="http://www.w3.org/1999/html">
    <div class="text-center">
        <h2 class="headline-07 md:mx-2 my-2">{{ data?.dsServicio}} {{data?.dsservicio}}</h2>
    </div>
</div>


<div class="flex flex-col md:flex-row w-full">
    <div class="w-full md:w-1/4 p-1 bg-white flex flex-col gap-4">
    </div>

    <!-- Formulario -->
    <div class="w-full md:w-1/2 p-1 bg-white flex flex-col gap-4">

        <!-- Formulario 1-->
        <div>
            <!-- Dirección de arrastre -->
            <div *ngIf="assistance?.data">
                <h2 class="headline-07 mb-2 md:mt-3 text-[#0E365A]">{{ displayServiceName }}</h2>
                <!-- ORIGINAL: <h2 class="headline-07 mb-2 md:mt-3 text-[#0E365A]">{{ data?.dsSubservicio }}{{data.dssubservicio}}</h2> -->
                <h5 class="headline-03 p-1">Expediente  #{{ assistance.data.clexpediente}}</h5>
                <h5 class="headline-03 p-1">Fecha {{formatDate(assistance?.data.fechaservicio)}}</h5>
                <br>
                <span [class]="getStatusClass(data?.clestatus || assistance?.data?.clestatus)">
                    <mat-icon class="icon-status">check_circle</mat-icon>
                    <p class="label-status">{{ getStatusDisplay(data?.clestatus || assistance?.data?.clestatus) }}</p>
                </span>

                <div class="text-[#0E365A]">
                    <br>
                    <!-- Título para servicios abiertos -->
                    <h2 class="headline-06 p-1" *ngIf="assistance?.data.dsestatus?.toLowerCase() === 'abierto'">Generado exitosamente</h2>
                    <!-- Mensaje para servicios funerarios -->
                    <p class="p-1 service-message" *ngIf="assistance?.data.dsestatus?.toLowerCase() === 'abierto' && isFuneralService()">Tu servicio fue abierto, en unos minutos uno de nuestros ejecutivos se pondrá en contacto contigo vía telefónica para dar seguimiento a tu solicitud, Te recomendamos tener a la mano el certificado de defunción.<br><br>Estamos para apoyarte en caso de dudas a través de las siguientes opciones:</p>
                    <!-- Mensaje para servicios no funerarios -->
                    <p class="p-1 service-message" *ngIf="assistance?.data.dsestatus?.toLowerCase() === 'abierto' && !isFuneralService()">Tu servicio fue abierto. Para brindarte una atención oportuna y de calidad, es muy importante que te pongas en contacto con nosotros. Estamos aquí para ayudarte.<br><br>Elige una de las siguientes opciones para continuar con tu atención:</p>
                    <!-- Mensaje para servicios cerrados -->
                    <h2 class="headline-06 p-1" *ngIf="assistance?.data.dsestatus?.toLowerCase() !== 'abierto'">Tu servicio fue {{(assistance?.data.dsestatus) | lowercase}}</h2>
                    <p>
                    </p>
                    <!-- <h5 class="headline-03 p-1">Fecha de servicio: {{ data?.fecharegistro | date:'dd/MM/yyyy' }}</h5> -->
                </div>

                <!-- Botones de contacto -->
                <div class="contact-buttons" *ngIf="!isExpedienteConcluido()">
                    <button class="contact-btn" *ngIf="showCallButton" (click)="llamarEmergencia()">
                        <mat-icon>phone</mat-icon>
                        <span>Llamar</span>
                    </button>
                    <button  *ngIf="activeWhatsApp()" class="contact-btn" (click)="openWhatsApp()">
                        <img src="assets/images/icons/whats.png" alt="WhatsApp">
                        <span>WhatsApp</span>
                    </button>
                </div>

                <!-- Mapa de tracking -->
                <div class="p-2 mb-2 mt-4" *ngIf="showTrackingMap()">
                    <iframe
                        [src]="trackingUrl | safe: 'resourceUrl'"
                        width="100%"
                        height="400"
                        frameborder="0"
                        style="border:0; border-radius: 12px;"
                        allowfullscreen>
                    </iframe>
                </div>

                <div *ngIf="mapExpanded" class="p-2 mb-2 space-y-2 border border-[#B0C4DE] rounded-[20px] " >
                    <div>
                      <p class="paragraph-default">{{ assistance?.data.direccion  || 'Cargando dirección...' }}</p>
                    </div>

                    <div class="w-full h-20 md:h-auto" >
                      <!-- Componente de mapa comentado temporalmente -->
                      <div class="map-placeholder" style="height: 264px; background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
                        <p>Mapa no disponible</p>
                      </div>
                    </div>
                  </div>


                <!-- Sección de detalles del servicio -->
                <div>
                    <h2 class="service-details-title p-1">Detalles del servicio</h2>
                    <p class="service-details-description p-1">Encuentra todos los datos importantes sobre esta solicitud.</p>
                </div>
                <br>

                <div class="text-[#0E365A] hidden">
                    <br>
                    <h2 class="headline-06 p-1">Comentarios adicionales</h2>
                    <p>
                        Agrega cualquier dato importante que necesitemos saber
                    </p>
                </div>

                <div class="bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] p-3 justify-between">
                    <div class="flex" *ngIf="hasAddress(assistance)">
                        <mat-icon *ngIf="showCarIcon">directions_car</mat-icon>
                        <h2 class="headline-06 p-1">Detalles del servicio</h2>
                    </div>
                    <div class="service-name p-2" (click)="toggleServiceDetails()">
                        <div class="service-name-content">
                            <mat-icon class="lock-icon">lock</mat-icon>
                            {{ displayServiceName }}
                            <!-- ORIGINAL: {{ data?.dsSubservicio || data?.dssubservicio }} -->
                        </div>
                        <mat-icon class="toggle-arrow" [class.expanded]="showServiceDetails">keyboard_arrow_down</mat-icon>
                    </div>

                    <div *ngIf="showServiceDetails">
                        <div *ngIf="hasAddress(assistance)" class="w-full md:h-auto p-2 detail-section">
                            <h4  class="detail-title">Dirección</h4>
                            <p class="detail-value"> {{ direccionSeleccionada || 'Cargando dirección...'}}</p>
                        </div>

                        <div class="w-full md:h-auto p-2 detail-section">
                            <h4 class="detail-title">Solicitante</h4>
                            <p class="detail-value">{{ getSolicitante() }}</p>
                        </div>

                        <div *ngIf="isOfiiceDoctor(data?.clsubservicio)" class="w-full md:h-auto p-2 detail-section">
                            <h4  class="detail-title">Especialidad</h4>
                            <p class="detail-value"> {{ assistance?.data?.descripcionocurrido || data?.descripcionocurrido}}</p>
                        </div>

                        <div class="w-full md:h-auto p-2 detail-section">
                            <h4 class="detail-title">Estatus</h4>
                            <p class="detail-value">{{dsEstatusBanamex || assistance?.data?.dssubestatusbanamex}}</p>
                        </div>

                        <div class="w-full md:h-auto flex justify-between p-2 detail-section">
                            <div class="flex-1">
                                <h4 class="detail-title">Fecha de solicitud</h4>
                                <p class="detail-value">{{ data?.fecharegistro | date:'dd/MM/yyyy' }}</p>
                            </div>
                            <div class="flex-1">
                                <h4 class="detail-title">Hora de solicitud</h4>
                                <p class="detail-value">{{ data?.fecharegistro | date:'shortTime' }}</p>
                            </div>
                        </div>

                        <div class="w-full md:h-auto p-2">
                            <h4 class="detail-title">Precio</h4>
                            <div class="flex items-center">
                                <mat-icon>workspace_premium</mat-icon>
                                <span class="detail-value">{{ priceText }}</span>
                            </div>
                        </div>
                    </div>
                </div>



            </div>

            <!-- Vehículo -->
            <div class="hidden">
                <h2 class="headline-04 mb-2 text-[#0E365A] my-4">¿Qué vehículo necesita el servicio?</h2>
                <mat-radio-group [(ngModel)]="selectedVehicle" class="space-y-2 block">
                    <div
                        class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 md:w-[327px]">
                        <mat-icon>directions_car</mat-icon>
                        <div class="ml-2">
                            <p class="font-semibold">Auto 1</p>
                            <p class="text-sm text-gray-500">Nissan Versa 2019, FHG-6454</p>
                        </div>
                        <mat-radio-button class="ml-auto" value="auto1"></mat-radio-button>
                    </div>
                    <div
                        class="flex items-center bg-[#D2E4FF29] border border-[#B0C4DE] rounded-[20px] px-4 py-2 md:w-[327px]">
                        <mat-icon>two_wheeler</mat-icon>
                        <div class="ml-2">
                            <p class="font-semibold">Moto 1</p>
                            <p class="text-sm text-gray-500">Royal Enfield 2023, RL-1234</p>
                        </div>
                        <mat-radio-button class="ml-auto" value="moto1"></mat-radio-button>
                    </div>
                </mat-radio-group>
                <button class="w-full mt-2 border border-[#0E365A] rounded-full p-2  mt-3 flex justify-between items-center">
                    <p class="button-small text-[#0E365A]">Agregar vehículo</p>
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <!-- Blindaje -->
            <div class="hidden">
                <div
                    class="flex items-center justify-between bg-[#D2E4FF29] border border-[#B0C4DE] rounded-full px-4 my-3 md:w-[327px]">
                    <h2 class="paragraph-medium text-[#0E365A]"><strong>¿Su auto tiene blindaje?</strong></h2>
                    <mat-radio-button [checked]="blindaje" (click)="blindaje = !blindaje"></mat-radio-button>
                </div>


                <div *ngIf="blindaje" class="mt-2">
                    <p class="text-sm text-gray-500 mb-1">Nivel de blindaje</p>
                    <mat-form-field appearance="fill" class="w-full">
                        <mat-select [(ngModel)]="nivelBlindaje">
                            <mat-option value="1">Nivel 1</mat-option>
                            <mat-option value="2">Nivel 2</mat-option>
                            <mat-option value="3">Nivel 3</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Sección de cancelación/dudas -->
            <div class="cancel-support-section">
                <h4 class="headline-04">¿Quieres cancelar o tienes dudas sobre tu servicio?</h4>
                <p>Por favor, comunícate con nosotros lo antes posible para poder brindarte el apoyo que necesitas. <a href="tel:5554800970" class="button-small text-[#0E365A]"> Llámanos.</a>
                </p>
            </div>
        </div>

        <!-- Formulario 2-->




    </div>
</div>
